module.exports = __webpack_public_path__ + "img/tollInvoicing.0a2ab232.svg";